import { useEffect, useState } from "react";
import { Form, Col, Row, Modal, Button } from "antd";
import useGet from "../../../global/hooks/useGet";
import usePost from "../../../global/hooks/usePost";
import usePut from "../../../global/hooks/usePut";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
import { useNavigate, useParams } from "react-router-dom";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import CommonButton from "../../../global/components/CommonButton";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import {
  CheckCircleOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  SendOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import ConfirmModal from "../../../global/components/ConfirmModal";
import useDelete from "../../../global/hooks/useDelete";
import OemIcon from "../../../assets/images/vectors/SideBarIcons/OemIcon";
import { AdminInvitation } from "../../../global/components/AdminInvitation";
import AccountForm from "../../../global/components/adminInfo";
import AccountCreationModal from "../../../global/components/AccountCreationModal";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { GlobalTable } from "../../../global/components/GlobalTable";
import AccountIcon from "../../../assets/images/vectors/SideBarIcons/AccountIcon";
import { OemAccountColumns } from "../Page/OemAccountColumns";
import { discountOptions } from "../../../utils/discountOptions";

export const OemForm = ({
  type,
  onCancel,
  isModalForm,
  setDefaultData: setAccountDefaultData,
  defaultData: accountDefaultData,
  createNew,
}) => {
  const [nextOemNo, setNextOemNo] = useState();
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  // const [licenseOp, setLicenseOp] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const [defaultData, setDefaultData] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [accountId, setAccountId] = useState(null);
  // const url = id && `${process.env.REACT_APP_API_URL}/api/oem/${id}`;
  const listUrl = `${process.env.REACT_APP_API_URL}/api/oems/?limit=10&order=desc`;
  // const licenseUrl = `${process.env.REACT_APP_API_URL}/api/licenses/`;
  const oemOptionUrl = `${process.env.REACT_APP_API_URL}/api/oems/options/`;
  const postUrl = `${process.env.REACT_APP_API_URL}/api/oems/`;
  const putUrl = `${process.env.REACT_APP_API_URL}/api/oems/${id}/`;
  const deleteUrl = `${process.env.REACT_APP_API_URL}/api/oems/${id}/`;
  const acountAdmin =
    type === "info" && id
      ? `${process.env.REACT_APP_API_URL}/api/accounts/?AccountTypeIds=4,5,6&OemNo=${id}`
      : null;

  const {
    data: adminData,
    loading: adminDataLoading,
    refetch: adminDataRefetch,
  } = useGet(acountAdmin);

  const deleteAdminUrl = `${process.env.REACT_APP_API_URL}/api/accounts/bulk-delete/`;

  const url =
    id && !createNew && `${process.env.REACT_APP_API_URL}/api/oems/${id}/`;
  const {
    data: deletedAdminData,
    loading: deletedAdminDataLoading,
    error: deletedAdminDataError,
    // deleteData,
    deleteMultiple,
  } = useDelete(deleteAdminUrl);

  const adminInfo =
    adminData?.data?.map((item) => ({ ...item, key: item.AccountNo })) || [];

  const { data, loading, error, refetch } = useGet(url);
  const { OemNo } = (data && data.data) || {};
  const {
    data: listData,
    loading: listDataLoading,
    error: listDataError,
    refetch: listDataRefetch,
  } = useGet(
    type === "info" || type === "edit"
      ? isModalForm
        ? listUrl
        : null
      : listUrl
  );

  const {
    data: OemOpData,
    loading: OemOpDataLoading,
    error: OemOpDataError,
  } = useGet(oemOptionUrl);

  const modifiedOemInfos = getModifiedResponse(OemOpData, "oeminfos");
  const modifiedLicenseOp = getModifiedResponse(OemOpData, "licenses");
  // const {
  //   data: licenseData,
  //   loading: licenseDataLoading,
  //   error: licenseDataError,
  //   refetch: licenseRefetch,
  // } = useGet(licenseUrl);
  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePost(postUrl);
  const {
    data: putData,
    loading: putLoading,
    error: putError,
    putData: putAction,
  } = usePut(putUrl);
  const {
    data: deletedData,
    loading: deletedDataLoading,
    error: deletedDataError,
    deleteData,
  } = useDelete(deleteUrl);

  const onFinish = async (values) => {
    const modValues = {
      ...values,
      MaxAccount: Number(values.MaxAccount) || undefined,
      Discount:
        typeof values.Discount === "number" ? values.Discount : undefined,
    };
    try {
      if (id && !isModalForm) {
        await putAction(modValues);
      } else {
        await postAction(modValues);
      }
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
  };

  useEffect(() => {
    if ((!id && [1, 2, 3].includes(userData?.role_value)) || createNew) {
      form.setFieldsValue({
        MaxAccount: 5,
      });
    }
    if (!id) {
      form.setFieldValue("Discount", 0);
    }
  }, [id]);

  const onReset = () => {
    isModalForm && form.resetFields();
    onCancel ? onCancel() : navigate(-1);
  };

  const onDeleteConfirm = async () => {
    try {
      if (selectedRowKeys.length) {
        await deleteMultiple({ ids: selectedRowKeys });
      } else {
        await deleteData();
      }
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
  };

  //toat for create
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong"
      );
    } else if (!postLoading && !postError && postData) {
      openConfirmNotification("Success");
      setAccountDefaultData &&
        setAccountDefaultData((prev) => {
          return {
            ...prev,
            OemNo: postData?.data?.OemNo,
            DealerNo: null,
            CustomerNo: null,
          };
        });
      refetch();
      listDataRefetch();
      setTimeout(() => {
        isModalForm ? onCancel() : navigate(-1);
      }, 200);
    }
  }, [postError, postData, postLoading]);

  //toat for update
  useEffect(() => {
    if (putError) {
      openErrorNotification(
        putError?.response?.data?.message || "Something went wrong"
      );
    } else if (!putLoading && !putError && putData) {
      openConfirmNotification("Success");

      refetch();
      setTimeout(() => {
        navigate("/oem");
      }, 200);
    }
  }, [putData, putLoading, putError]);

  // console.log(listData?.data);
  useEffect(() => {
    if (type !== "info") {
      const nextOem = Number(listData?.data[0]?.OemNo);
      if (nextOem < 255) {
        setNextOemNo(nextOem + 1);
      }
    }
  }, [listDataLoading, listData, type]);

  // Set default field value
  useEffect(() => {
    if (isModalForm || !id) {
      form.setFieldsValue({
        OemNo: String(nextOemNo),
        OemInfoNo: modifiedOemInfos[0]?.value,
      });
    }

    if (defaultData) {
      // licenseRefetch();
      form.setFieldsValue({
        LicenseNo: defaultData?.LicenseNo || null,
      });
    }
  }, [nextOemNo, modifiedOemInfos]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    fixed: true,
  };
  const onRow = (record, rowIndex) => {
    return {
      onClick: (event) => {},
    };
  };

  useEffect(() => {
    if (!id || loading) return;
    const getOemInfoById = () => {
      try {
        if (data?.data && !isModalForm) {
          form.setFieldsValue({
            OemNo: String(data?.data?.OemNo) ?? id,
            OemName: data.data.OemName,
            OemDesc: data.data.OemDesc,
            Domain: data.data.Domain,
            Discount: data.data.Discount,
            LicenseNo: data.data.LicenseNo,
            OemInfoNo: data.data.OemInfoNo,
            MaxAccount: data.data.MaxAccount,
          });
        } else {
          console.warn("No data found for the given ID");
        }
      } catch (error) {
        if (!loading) {
          openErrorNotification("Error fetching data!");
        }
      }
    };

    getOemInfoById();
  }, [id, data, loading, form]);

  // useEffect(() => {
  //   if (!licenseDataLoading && licenseData) {
  //     function filterInitialLicenses(data) {
  //       return data.map((item) => ({
  //         value: item?.LicenseNo,
  //         label: item?.LicenseName,
  //       }));
  //     }

  //     const filteredLicenses = filterInitialLicenses(licenseData?.data);
  //     setLicenseOp(filteredLicenses);
  //   }
  // }, [licenseDataLoading, licenseData]);

  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      // refetch();
      navigate("/oem");
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong"
      );
    }
  }, [deletedData, deletedDataError]);

  useEffect(() => {
    if (deletedAdminData && !deletedAdminDataError) {
      openConfirmNotification("Success");
      // refetch();
      adminDataRefetch();
    } else if (deletedAdminDataError) {
      openErrorNotification(
        deletedAdminDataError?.response?.data?.message || "Something went wrong"
      );
    }
  }, [deletedAdminData, deletedAdminDataError]);

  //sent admin invitation
  const handleInvitation = (e) => {
    setIsModalOpen(true);
  };
  const breadcrumbItems = [
    {
      label: "OEM",
      href: "/oem",
    },
    {
      label: id ? (type === "info" ? "Information" : "Edit") : "Add",
      href: id
        ? type === "info"
          ? `/oem/info/${id}`
          : `/oem/edit/${id}`
        : "/oem/add",
    },
  ];

  const buttonsData =
    type === "info"
      ? [
          !adminInfo && {
            label: "Oem Invitation",
            icon: <SendOutlined />,
            onClick: handleInvitation,
          },
          {
            label: "Edit",
            icon: <EditOutlined />,
            onClick: () => {
              navigate(`/oem/edit/${id}`);
            },
          },
          {
            label: "Delete",
            icon: <DeleteOutlined />,
            onClick: () => {
              setShowModal(true);
            },
          },
          {
            label: "List",
            icon: <UnorderedListOutlined />,
            onClick: () => {
              navigate(-1);
            },
          },
        ].filter(Boolean)
      : [
          {
            label: "Apply",
            icon: <CheckCircleOutlined />,
            onClick: () => form.submit(),
          },
          {
            label: "Cancel",
            icon: <CloseOutlined />,
            onClick: onReset,
          },
        ];

  const accountButtonsData = [
    {
      label: "Add",
      icon: <PlusOutlined />,
      onClick: () => {
        setShowAccountModal(true);
      },
    },
    ,
    {
      label: "Delete",
      icon: <DeleteOutlined />,
      disabled: selectedRowKeys.length === 0,
      onClick: () => {
        setShowModal(true);
      },
    },
  ];

  // console.log("defaultData", defaultData);
  // console.log("accountDefaultData", accountDefaultData);
  // const handleCreateNew = (type) => {
  //   setModalType(type);
  //   setIsOpenModal(true);
  // };
  return (
    <div>
      {/* <AccountCreationModal
        isOpenModal={isOpenModal}
        modalType={modalType}
        setIsOpenModal={setIsOpenModal}
        setDefaultData={setDefaultData}
      /> */}
      {!isModalForm && (
        <div className="pb-4 sticky -mt-4 pt-[6px] top-[55px] z-10 bg-[#f4f5f9]">
          <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
            <CommonButton buttonsData={buttonsData} />
          </CommonBreadcrumb>
        </div>
      )}
      <div
        className={`bg-white overflow-hidden ${
          isModalForm ? "" : "border rounded-[4px]"
        }`}
      >
        <Form
          validateTrigger={"onChange"}
          form={form}
          onFinish={onFinish}
          scrollToFirstError
          layout={"vertical"}
          autoComplete={"off"}
        >
          {!isModalForm && (
            <div className="flex items-center bg-gray-200 p-2.5">
              <OemIcon className="text-[18px] text-black " />
              <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                OEM
              </span>
            </div>
          )}
          <div className="px-2 pt-1 pb-3">
            <Row gutter={isModalForm ? [0, 0] : [16, 8]}>
              <Col
                xs={!isModalForm && 24}
                sm={!isModalForm && 24}
                md={!isModalForm && 12}
                lg={!isModalForm && 12}
                xl={!isModalForm && 12}
                span={24}
              >
                <CustomInput
                  label="OEM No"
                  name="OemNo"
                  disabled={type === "info" || type === "edit"}
                  type="number"
                  required
                  loading={loading}
                  rules={[
                    {
                      validator: (_, value) => {
                        if (value && value > 255) {
                          return Promise.reject(
                            new Error(
                              "OEM No must be less than or equal to 255!"
                            )
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                />
              </Col>
              <Col
                xs={!isModalForm && 24}
                sm={!isModalForm && 24}
                md={!isModalForm && 12}
                lg={!isModalForm && 12}
                xl={!isModalForm && 12}
                span={24}
              >
                <CustomInput
                  label="OEM Name"
                  name="OemName"
                  required
                  disabled={type === "info"}
                  loading={loading}
                />
              </Col>

              <Col
                xs={!isModalForm && 24}
                sm={!isModalForm && 24}
                md={!isModalForm && 12}
                lg={!isModalForm && 12}
                xl={!isModalForm && 12}
                span={24}
              >
                <CustomInput
                  label="Description"
                  name="OemDesc"
                  disabled={type === "info"}
                  loading={loading}
                />
              </Col>
              <Col
                xs={!isModalForm && 24}
                sm={!isModalForm && 24}
                md={!isModalForm && 12}
                lg={!isModalForm && 12}
                xl={!isModalForm && 12}
                span={24}
              >
                <CustomInput
                  label="Domain"
                  name="Domain"
                  disabled={type === "info"}
                  loading={loading}
                />
              </Col>
              {[1, 2, 3].includes(userData?.role_value) && (
                <Col
                  xs={!isModalForm && 24}
                  sm={!isModalForm && 24}
                  md={!isModalForm && 12}
                  lg={!isModalForm && 12}
                  xl={!isModalForm && 12}
                  span={24}
                >
                  <CustomInput
                    label="Max Account"
                    name="MaxAccount"
                    disabled={type === "info"}
                    // required
                    type="number"
                    loading={loading}
                  />
                </Col>
              )}

              <Col
                xs={!isModalForm && 24}
                sm={!isModalForm && 24}
                md={!isModalForm && 12}
                lg={!isModalForm && 12}
                xl={!isModalForm && 12}
                span={24}
              >
                <CustomSelect
                  label="Discount"
                  name="Discount"
                  options={discountOptions}
                  placeholder="Please select"
                  disabled={type === "info"}
                  allowClear={false}
                  loading={loading}
                />
              </Col>
              <Col
                xs={!isModalForm && 24}
                sm={!isModalForm && 24}
                md={!isModalForm && 12}
                lg={!isModalForm && 12}
                xl={!isModalForm && 12}
                span={24}
              >
                <CustomSelect
                  label="License"
                  name="LicenseNo"
                  options={modifiedLicenseOp}
                  placeholder="Please select"
                  disabled={type === "info"}
                  required
                  // handleCreateNew={handleCreateNew}
                  type={"License"}
                  loading={loading}
                />
              </Col>
              <Col
                xs={!isModalForm && 24}
                sm={!isModalForm && 24}
                md={!isModalForm && 12}
                lg={!isModalForm && 12}
                xl={!isModalForm && 12}
                span={24}
              >
                <CustomSelect
                  label="OEM Info"
                  name="OemInfoNo"
                  options={modifiedOemInfos}
                  placeholder="Please select"
                  disabled={type === "info"}
                  required
                  loading={loading}
                />
              </Col>
            </Row>
          </div>
        </Form>

        {isModalForm && (
          <div className="flex justify-center space-x-2 mt-2.5">
            <Button
              type="primary"
              className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium flex items-center "
              onClick={() => form.submit()}
            >
              <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
              <span className="">Apply</span>
            </Button>
            <Button className="reset-button" onClick={onReset}>
              <CloseOutlined />
              <span className="">Cancel</span>
            </Button>
          </div>
        )}
      </div>
      {type === "info" && (
        <>
          <div className="flex justify-between items-center my-2">
            <div className="flex">
              <span className="mr-2 text-[18px] text-black">
                <AccountIcon />
              </span>
              <span className="text-[.935rem] text-black font-['Poppins']">
                OEM Accounts
              </span>
            </div>
            <div className="flex justify-end mb-2">
              <CommonButton buttonsData={accountButtonsData} />
            </div>
          </div>
          <>
            <GlobalTable
              columns={OemAccountColumns(
                hoveredRow,
                setShowModal,
                setSelectedRowKeys,
                setAccountId,
                setShowAccountModal
              )}
              dataSource={adminInfo}
              rowSelection={rowSelection}
              // onRow={onRow}
              onRow={(record, rowIndex) => {
                return {
                  onMouseEnter: () => setHoveredRow(rowIndex),
                  onMouseLeave: () => setHoveredRow(null),
                  ...onRow?.(record, rowIndex),
                };
              }}
              loading={adminDataLoading}
            />
          </>
        </>
      )}
      {/* {adminInfo && (
        <AccountForm
          adminInfo={adminInfo}
          title="Oem Admin"
          icon={<OemIcon />}
          type={type}
        />
      )} */}

      <AccountCreationModal
        isOpenModal={showAccountModal && accountId === null}
        modalType={"AccountCreate"}
        setIsOpenModal={setShowAccountModal}
        defaultData={{
          OemNo: Number(id),
          // DealerNo: Number(id),
          // CustomerNo: Number(id),
        }}
        isModal={true}
        isModalForm={true}
        refetch={adminDataRefetch}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            <AccountIcon className="text-[15px] text-black ml-1" />
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              Add Account
            </span>
          </div>
        }
      />
      <AccountCreationModal
        isOpenModal={showAccountModal && accountId !== null}
        modalType={"AccountEdit"}
        setIsOpenModal={setShowAccountModal}
        defaultData={{
          OemNo: Number(id),
          AccountNo: accountId,
        }}
        isModal={true}
        // isModalForm={true}
        refetch={adminDataRefetch}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            <AccountIcon className="text-[15px] text-black ml-1" />
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              Edit Account
            </span>
          </div>
        }
        setAccountId={setAccountId}
      />
      <ConfirmModal
        showModal={showModal}
        setShowModal={setShowModal}
        onDeleteConfirm={onDeleteConfirm}
      />
      <Modal
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            <SendOutlined className="text-[15px] text-black ml-1 " />
            <span className="text-[14px] font-[Poppins]   ml-2">
              Send Invitation
            </span>
          </div>
        }
        open={isModalOpen}
        closable={false}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={580}
        centered
        destroyOnClose
      >
        <AdminInvitation
          payload={{ OemNo, AccountType: 4 }}
          setIsModalOpen={setIsModalOpen}
        />
      </Modal>
    </div>
  );
};
